import {
    ConfigurationTemplateIcon,
    DeviceSettingsIcon,
} from "@components/Common/SvgIcons";

export type CardMenuType = {
    Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    description?: string;
    title: string;
    number: number;
    path: string;
};

export const CARD_MENU_LIST: CardMenuType[] = [
    {
        title: "Template Setup",
        number: 0,
        Icon: ConfigurationTemplateIcon,
        description:
            "In this section, you have the ability to configure the POS, allowing you to customize them according to the specific needs of your store.",
        path: "/pos-project-setting",
    },
    {
        title: "Peripheral setting",
        number: 0,
        Icon: DeviceSettingsIcon,
        description:
            "In this section, you can make the declaration and configuration of the POS screens of the store, as well as the peripherals associated with the POS application, such as printers, payment terminals, and more.",
        path: "/pos-peripheral-setting",
    },
];
